var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05348 20.75C6.47501 12.7542 11.5606 5.30021 15.8149 0.847195C16.203 0.440944 15.7649 -0.202116 15.2706 0.0649887C2.83106 6.78693 -0.113559 22.0148 0.00330216 29.7222C0.00110518 29.8091 0 29.8962 0 29.9836C0 35.5154 4.42992 39.9998 9.8945 39.9998C15.3591 39.9998 19.789 35.5154 19.789 29.9836C19.789 24.4517 15.3591 19.9673 9.8945 19.9673C8.53234 19.9673 7.23447 20.2459 6.05348 20.75Z",
    fill: "#15236E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2644 20.75C35.6859 12.7542 40.7715 5.30021 45.0258 0.847195C45.4139 0.440944 44.9758 -0.202116 44.4815 0.0649887C32.042 6.78693 29.0974 22.0148 29.2142 29.7222C29.212 29.8091 29.2109 29.8962 29.2109 29.9836C29.2109 35.5154 33.6409 39.9998 39.1054 39.9998C44.57 39.9998 48.9999 35.5154 48.9999 29.9836C48.9999 24.4517 44.57 19.9673 39.1054 19.9673C37.7433 19.9673 36.4454 20.2459 35.2644 20.75Z",
    fill: "#15236E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.7ab3e215418520d21ceb0df8982c649a.svg";
export { ForwardRef as ReactComponent };